import { autocompleteHistoryLSKey } from '../../../Assets/configuration/index.js';

const getHistory = () => {
    const rawValue = localStorage.getItem(autocompleteHistoryLSKey);
    return rawValue ? JSON.parse(rawValue) : [];
};

export default getHistory;
